import { Tooltip } from "@mui/material";
import { motion } from "motion/react";
import { CiEdit } from "react-icons/ci";
import { RiInboxArchiveLine } from "react-icons/ri";
import { Patient, TimeToTakePills } from "../types";
import { PARTS_OF_THE_DAY } from "../utils";

type PropsType = {
  isLastItem: boolean;
  loadingMutation?: boolean;
  item: Patient;
  timeFilter: TimeToTakePills | "";
  onItemClick: (item: Patient) => void;
  onEditPatient?: (patient: Patient) => void;
  archivePatient: (id: string) => void;
  onPillsClick: () => void;
};

const ProfileRow = ({
  item,
  isLastItem,
  loadingMutation,
  timeFilter,
  onItemClick,
  onEditPatient,
  archivePatient,
}: // onPillsClick,
PropsType) => {
  const takenPillsIn = [...new Set(item.todayTakenPillsHistory)];
  const patirntTakenThePills = timeFilter
    ? item.todayTakenPillsHistory?.includes(timeFilter)
    : false;

  item.timeToTakePills;

  return (
    <motion.div
      key={item._id}
      initial={{ opacity: 0, y: 0 }}
      animate={{ opacity: 1, y: 20 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.3 }}
      layout
      className={`flex justify-between hover:bg-blue-200 hover:cursor-pointer items-center mb-4 p-2 odd:bg-gray-50 border rounded ${
        isLastItem ? "mb-14" : ""
      }`}>
      {loadingMutation && (
        <div className="absolute inset-0 bg-gray-100 animate-pulse z-10 rounded">
          <div className="h-full w-full bg-gradient-to-r from-gray-100 via-gray-50 to-gray-100 animate-shimmer"></div>
        </div>
      )}
      <div className="flex flex-col flex-1" onClick={() => onItemClick(item)}>
        <div className="flex flex-1">
          <div className="flex-1">
            <div className="flex gap-4 text-right items-center">
              {timeFilter && (
                <Tooltip
                  title={
                    patirntTakenThePills
                      ? "הדייר לקח את הכדורים"
                      : "הדייר לא לקח את הכדורים"
                  }>
                  <div
                    className={`w-3 h-3 ${
                      patirntTakenThePills ? "bg-green-500" : "bg-red-500"
                    } rounded-full`}></div>
                </Tooltip>
              )}
              <div className="rounded-full w-7 sm:w-14">
                <img
                  className="w-full rounded-full"
                  src={item.defaultImg}
                  alt="profileImage"
                />
              </div>
              <p className="text-sm sm:text-md font-bold">{item.name}</p>
            </div>
          </div>
          <div className="flex items-center gap-2 sm:gap-8">
            {onEditPatient && (
              <button
                className="text-center items-center flex flex-col border rounded px-2 hover:scale-110 hover:border-[#C64192]"
                onClick={(e) => {
                  e.stopPropagation();
                  onEditPatient(item);
                }}>
                <span>עריכה</span>
                <CiEdit className="text-lg sm:text-2xl" />
              </button>
            )}
            <button
              className="text-center items-center flex flex-col border rounded px-2 hover:scale-110 hover:border-[#C64192]"
              onClick={(e) => {
                e.stopPropagation();
                archivePatient(item._id);
              }}>
              <span>לארכיון</span>
              <RiInboxArchiveLine className="text-lg sm:text-2xl" />
            </button>
          </div>
        </div>
        <div className="flex-1 border-t mt-2 pt-2">
          <p className="text-right underline mb-1">סטטוס כדורים:</p>
          <div className="flex gap-2 flex-row-reverse justify-end">
            {item.timeToTakePills.map((taken, index) => {
              return (
                <div
                  key={taken + index}
                  className={`border rounded p-2 ${
                    takenPillsIn.includes(taken)
                      ? "bg-green-300 border-green-300"
                      : ""
                  }`}>
                  {/* @ts-ignore */}
                  {PARTS_OF_THE_DAY[taken]?.labelHe || ""}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProfileRow;
